import $ from 'jquery';

const $webinarGoToWebinarButton = $( '.js-gotowebinar-button' );
const $webinarCalendarButtons = $( '.js-gotowebinar-calendar-buttons' );

const $webinarCover = $( '.js-webinar-cover' );
const $webinarSource = $( '.js-webinar-source' );

const virtualMarketoFormID = window.securelist2020Data.marketoVirtualForm;

let marketoForm = '';
let $wrapper = '';
let triggerIsCalendarButton = false;
let joinUrl = $webinarGoToWebinarButton.attr( 'data-join-url' );

if ( $webinarGoToWebinarButton && $webinarGoToWebinarButton.length && virtualMarketoFormID && $webinarCover && $webinarSource ) {
	try {
		const marketoBaseURL = window.securelist2020Data.marketoBaseURL;
		const munchkinID = window.securelist2020Data.munchkinID;

		MktoForms2.loadForm( marketoBaseURL, munchkinID, virtualMarketoFormID, function( form ) {
			let doingAjax = false;

			form.onSuccess( function() {
				if ( ! doingAjax ) {
					$.ajax( {
						url: window.securelist2020Data.ajaxUrl,
						data: {
							action: 'securelist_gotowebinar_form_success',
							postID: $wrapper.attr( 'data-post-id' ),
							webinarURL: $( '.js-copy-text' ).attr('href'),
						},
						method: 'GET',
						beforeSend: function() {
							doingAjax = true;
						},
					} )
						.success( function() {
							doingAjax = false;
						} )
						.error( function() {
							doingAjax = false;
						} );
				}

				return false;
			} );

			$( $webinarGoToWebinarButton ).on( 'click', function(e) {
				e.preventDefault();

				grecaptcha.execute();

				if ( ! $wrapper || ! $wrapper.length ) {
					$wrapper = $( this );
				}

				if ( joinUrl ) {
					navigator.clipboard.writeText(joinUrl).then(function() {}, function(err) {});
				}

				$wrapper.html( $wrapper.attr( 'data-loading' ) );

				marketoForm = form;
				triggerIsCalendarButton = false;
			} );

			if ( $webinarCalendarButtons && $webinarCalendarButtons.length ) {
				$webinarCalendarButtons.on( 'click', '> a', function(e) {
					if ( ! $wrapper || ! $wrapper.length ) {
						$wrapper = $( $webinarGoToWebinarButton );
					}

					grecaptcha.execute();

					marketoForm = form;
					triggerIsCalendarButton = true;
				} );
			}
		} );
	} catch(e) {
		if (e instanceof ReferenceError) {
			console.error( 'MktoForms2 is not defined ' );
		}
	}
}

let doingAjax = false;

const getWebinar = function() {
	if ( ! $wrapper || ! marketoForm ) {
		return;
	}

	if ( ! doingAjax ) {
		$.ajax( {
			url: window.securelist2020Data.ajaxUrl,
			data: {
				action: 'securelist_gotowebinar_join',
				postID: $wrapper.attr( 'data-post-id' ),
				webinarID: $wrapper.attr( 'data-gotowebinar-id' ),
				webinarTitle: $wrapper.attr( 'data-gotowebinar-title' ),
			},
			dataType: 'json',
			method: 'GET',
			beforeSend: function() {
				doingAjax = true;
			},
		} )
			.success( function( response ) {
				if ( response.success ) {
					marketoForm.setValues( {
						'Email': response.userEmail,
					} );

					const recaptchaResponse = window.grecaptcha && window.grecaptcha.getResponse();

					if ( ! recaptchaResponse ) {
						if ( marketoForm.submittable() ) {
							marketoForm.submittable( false );
						}

						window.grecaptcha.reset();
					} else {
						marketoForm.addHiddenFields({
							reCAPTCHAInvisibleFormResponse: recaptchaResponse,
						});
	
						if ( ! marketoForm.submittable() ) {
							marketoForm.submittable( true );
						}
					}

					marketoForm.submit();

					if ( response.registrationResult && ! triggerIsCalendarButton ) {
						$webinarGoToWebinarButton.before( response.registrationResult );
						$webinarGoToWebinarButton.remove();

						$( '.js-copy-link' ).removeClass( 'u-hidden' );
						$( '.js-gotowebinar-calendar-buttons' ).removeClass( 'u-hidden' );
					}

					grecaptcha.reset();
				}

				doingAjax = false;
			} )
			.error( function(response) {
				doingAjax = false;
			} );
	}
};

window.onSubmitGoToWebinar = function() {
	getWebinar();
};
